<template lang="pug">
v-app
  section
    .d-flex.row.flex-row.align-items-end
      .col-12
        h2.ps_titulo
          i {{title}}
    .d-flex.row.flex-row.text-right
      .col-12
        p 
          | Tu meta para esta semana 
          span.h3 {{user.profile.suggested_cp}} {{short_title}}
    .d-flex.row.flex-row.align-items-start
      .col-5
        .card.p-4.ad_border1-secondary.rounded-xl
          .form-group.row
            .col-12
              //- .ad_select
                //- select(v-model='selectedColaborador' )
                //-   option(:value="null" disabled) Selecciona Colaborador
                //-   option(:value="colaborador" v-for="colaborador in team") {{colaborador.name}}
              multiselect(
                v-model="selectedColaborador",
                :options="team",                
                :multiple="true",
                :close-on-select="true",
                :clear-on-select="false",
                :preserve-search="true",
                placeholder="Selecciona Colaboradores",
                label="name",
                track-by="_id",
              )
          .form-group.row.mt-3
            .col-12
              multiselect(
                v-model="selectedObjetivo",
                :options="currentWeekObjectives",                
                :multiple="true",
                :close-on-select="true",
                :clear-on-select="false",
                :preserve-search="true",
                placeholder="Seleccione objetivos",
                :custom-label="customLabel",
                track-by="_id",
              )                
                template(slot="option", slot-scope="props")
                  .col.pr-0(:title="`${props.option.travel ? props.option.travel.name : ''}/${props.option.product ? props.option.product.name : ''}/${props.option.segment ? props.option.segment.name : ''}/${props.option.business_type.name}`")
                    span {{props.option.name ? props.option.name : 'Sin Kpi'}}
                  .col.pr-0(:title="`${props.option.travel ? props.option.travel.name : ''}/${props.option.product ? props.option.product.name : ''}/${props.option.segment ? props.option.segment.name : ''}/${props.option.business_type.name}`")
                    i.icon-letters.icon-letters__viaje.mr-1(v-if="props.option.travel") V
                    i.icon-letters.icon-letters__producto.mr-1(v-if="props.option.product") P
                    i.icon-letters.icon-letters__segmento.mr-1(v-if="props.option.segment") S
                    i.icon-letters.icon-letters__negocio.mr-1 N
          //- .form-group.row(v-if="title === 'Seguimiento Diario'")
          //-   .col-12
          //-     .div
          //-       small.col.flex-row Registro KPI Personal
          //-       .input-refresh
          //-         input(type="text" v-model="kpiPersonal" maxlength='3')
          //-         | %

          .form-group.row(v-show="user.profile.leader_leaders")
            .col-12.mt-3
              h5.ad_text-primary.font-weight-bold Objetivo de Desarrollo Personal
          .form-group.row(v-show="user.profile.leader_leaders")
            .col-12
              .ad_select.ad_border1-primary
                select(v-model='selectedCategoria', @change='getSubByCat($event)')
                  option(:value="null" disabled) Selecciona Categoría
                  option(:value="category", v-for="category in categories") {{category.name}}
          .form-group.row(v-show="user.profile.leader_leaders")
            .col-12
              .ad_select.ad_border1-primary
                select(v-model='selectedObjetivoDesarrollo' )
                  option(:value="null" disabled) Selecciona Objetivo de desarrollo
                  option(:value="objetivoDesarrollo" v-for="objetivoDesarrollo in subcategories") {{objetivoDesarrollo.name}}
          .form-group.row.mt-3
            .col-6.position-relative
              v-menu(ref='menu', v-model='menu', :close-on-content-click='true', :nudge-right='40', lazy, transition='scale-transition', offset-y, full-width, min-width='290px', content-class='date-picker')
                v-text-field.date-input.pt-0.mt-0(slot='activator', v-model='date', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                v-date-picker(v-model='date', no-title, locale="es",  :min="startWeek", :max="endWeek", @input="menu2 = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")
            .col-6.d-flex.justify-content-end
              button.btn.btn-secondary.btn__large(:class='{disabled : (user.profile.leader_leaders ? (!selectedObjetivoDesarrollo) : !selectedObjetivo)}' @click="create()")
                | Agregar
                i.fas.fa-plus.border.border-white.rounded-circle.p-1.ml-2

      .col-7
        .card.p-4.ad_border1-secondary.rounded-xl
          h3.mb-4.ad_text-primary
            //- i Seguimientos diarios para la semana
            i {{title}}
          
          .col-12.text-center.rounded-lg.ad_bg-gray.pt-3(v-show='tracings.length == 0')
            p.muted Aún no ha seleccionado nuevos objetivos
          .row
            .col-12(v-show='tracings.length > 0')
              table.large-table.w-100
                thead
                  tr
                    th.font-weight-bold Colaborador
                    th.font-weight-bold Objetivo
                    th.font-weight-bold.text-center Fecha
                    th
                tbody
                  tr(v-for="(tr, index) in tracings")
                    td
                      div
                        table.w-100
                          tr(v-for="(user, ind) in tr.users")
                            td
                              | {{(user.name) ? user.name : ''}}
                    td
                      div
                        table.w-100
                          tr(v-for="(obj, i) in tr.objectives")
                            td
                              i.icon-letters.icon-letters__kpi.mx-1 A
                              | {{ obj.kpi ? obj.kpi.name : 'Sin Kpi' }}
                    td.text-center
                      div
                        | {{tr.date | DateFormat}}
                    td(width='45')
                      div
                        button.btn-icon.p-0.ad_text-danger.border-btnicon-danger.rounded-circle(@click="closeTrading(tr._id)", :id="'cerrar' + index")
                          i.fas.fa-times.p-0
                        b-tooltip(:target="'cerrar' + index" , placement='top')
                          | Eliminar proceso



          .col-12.text-center.mt-4.ad_bg-warningLight.rounded-lg.py-2(v-show="tracings.length < user.profile.suggested_cp")
            p.ad_text-warningDark.m-0
              i.fas.fa-exclamation-triangle.mr-2
              i Falta por asignar {{suggested}} {{short_title}}
    
    v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Actualizar Objetivo
      section.py-4.px-2.overflowy-auto
        .col-12
          label
            p.icon-letters.mr-1 Via
            | Viaje
          label.ml-3
            p.icon-letters.mr-1 Kpi
            | KPI de Negocio 1
        .col-12
          h4 KPI Adherencia
        .col-12.mt-4
          table.w-100
            tbody
              tr
                td.py-2 Meta
                td.ad_text-grayMedio 90%
                td &nbsp;
                td Cumple
                td
                  c-form-radio.ad_radio.ad_radio-cumple(name="cumplimiento" v-model="cumplimiento" value="true" label="")
              tr
                td.py-2 Registro semana anterior
                td.ad_text-grayMedio 90%
                td &nbsp;
                td No cumple
                td
                  c-form-radio.ad_radio.ad_radio-nocumple(name="cumplimiento" v-model="cumplimiento" value="false" label="")
              tr
                td.py-2 Registro actualizado
                td.ad_text-grayMedio 90%
                td &nbsp;
                td(colspan='2')
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario' rows='3')
          .form-group.justify-content-between
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cerrar objetivo
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="moveobjetivo = true; drawer = false;")
              | Continuar objetivo
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Comentarios
          .row.mb-3(v-for='n in 4')
            .col-4.pr-0
              p.font-weight-bold.m-0 Francisco G
              small.d-block 10-05-2018
              small.d-block 20:30 hrs.
            .col-8.pl-0
              .dialog-box
                p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa ullam facilis provident quia delectus, aut ad odio, non debitis accusamus. Hic quis sit repudiandae, veritatis perferendis magni distinctio minima tempore.
    
    v-navigation-drawer(v-model='drawer2', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      section.py-4.px-2.overflowy-auto
        .col
          label
            p.icon-letters.mr-1 Via
            | Viaje
          label.ml-3
            p.icon-letters.mr-1 Kpi
            | KPI de Negocio 1
        .row.align-items-end
          .col
            .col-12
              h4 KPI Adherencia
          .col-auto.pr-5
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Registro
              span.ad_text-grayDark 60%
            p.d-inline-block.mb-0.ad_text-grayMedio
              sup Meta
              span 90%
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario' rows='3')
          .form-group.justify-content-between
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer2 = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="drawer2 = false")
              | Agregar comentario
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          .row.mb-3(v-for='n in 4')
            .col-4.pr-0
              p.font-weight-bold.m-0 Francisco G
              small.d-block 10-05-2018
              small.d-block 20:30 hrs.
            .col-8.pl-0
              .dialog-box
                p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa ullam facilis provident quia delectus, aut ad odio, non debitis accusamus. Hic quis sit repudiandae, veritatis perferendis magni distinctio minima tempore.
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import Flatpickr from 'vendors/cover/vendors/flatpickr'

export default {
  name: 'SeguimientoDiario',
  props: ['clickedNext', 'currentStep'],
  components: {
     Flatpickr
  },
  data() {
      return {
        menu: false,
        date: null, 
        cumplimiento: 'cumple',
        drawer: null,
        drawer2: null,
        overlay: false,
        moveobjetivo: false,
        selectedObjetivo: null,
        selectedObjetivoDesarrollo: null,
        selectedColaborador: null,
        selectedCategoria: null,
        title:  'CP',
        categories: [],
        subcategories: [],
        tracings: [],
        currentWeekObjectives: [],
        user: {},
        plan: null,
        team: null,
        title: null,
        suggested: 0,
        objetivos: [ '6 Pasos Tecnico - Informe Avance','% Resolución sin participación ATT – CR <3hrs'],
        colaboradores: [
          'Francisco Gutierrez',
          'Alejandro Alvarez',
          'Marcela Verdugo',
          'Cristian Fuentes',
          'Horacio Riquelme',
        ],        
        kpiPersonal: 0,        
        startWeek: moment().utc().startOf('isoWeek').subtract(1, "days").toISOString(),
        endWeek: moment().utc().endOf('isoWeek').toISOString()
      }
  },
  methods: {
    moment,
    ...mapActions('user', [
      'myTeam'    
    ]),
    ...mapActions('category', [
      'categoriesList'
    ]),
    ...mapActions('subcategory', [
      'byCategoryId'
    ]),    
    ...mapActions('objective', [
      'getObjectiveByPlan', 'getObjByPlanForList'
    ]),
    ...mapActions('tracing', [
      'createTracing', 'getTracingByPlan', 'closeTracing'
    ]),
    ...mapActions('personalcommitments', [
      'createPC', 
    ]),
    finishCreation() {
      const vm = this;
      const loading = vm.$toast.loading('Creando...');
      let currentWeek = moment().isoWeek()
      const type = vm.user.profile.auth.tabs.indexOf("confirmacion_procesos") != -1 ? 'CP' : 'SD' 
      let cdt = moment();
      let tracingDate = moment(vm.date).second(cdt.second()).minute(cdt.minute()).hour(cdt.hour());
      let tr = {
        name: `C.P/S.D semana ${currentWeek}`,
        date: tracingDate,
        objectives: vm.selectedObjetivo,
        users: vm.selectedColaborador,
        category: vm.selectedCategoria,
        subcategory: vm.selectedObjetivoDesarrollo,
        user_leader: vm.user.id,
        plan: vm.plan._id,
        type
      }      
      // if (type === 'SD') {
        //   tr.personal_kpi = vm.kpiPersonal
      // }
      vm.createTracing(tr).then(async tracing => {
        if (vm.user.profile.leader_leaders) {
          for (let col of vm.selectedColaborador) {
            const data = {
              category: vm.selectedCategoria,
              subcategory: vm.selectedObjetivoDesarrollo,
              user: col,
              tracing: tracing._id,
              name: 'Creado en planificacion semanal',
              date: vm.date
            }          
            const pcs = await vm.createPC(data)
          }    
        }        
        vm.tracings.push(vm.$store.getters['tracing/getWTracing'])        
        vm._clearForm()        
        loading.hide()
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'C.P./S.D creado',
          closeable: true,
          duration: 5000
        })
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      });
    },
    create() {
      const vm = this
      const { selectedObjetivo, selectedObjetivoDesarrollo, selectedColaborador, selectedCategoria, date } = vm
      if (vm.user.profile.leader_leaders) {
        if (selectedColaborador === null || selectedObjetivo === null || date === null || selectedObjetivoDesarrollo === null || selectedCategoria === null || selectedColaborador.length === 0) {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: "Porfavor rellene todos los campos",
            closeable: true,
            duration: 5000
          })
        } else {
          vm.finishCreation()
        }
      } else {
        if (selectedColaborador === null || selectedObjetivo === null || date === null || selectedColaborador.length === 0) {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: "Porfavor rellene todos los campos",
            closeable: true,
            duration: 5000
          })
        } else {
          vm.finishCreation()
        }
      }
    },
    loadObjectivesByPlan() {
      const vm = this      
      vm.getObjectiveByPlan(vm.plan._id).then(() => {
        vm.objectives = vm.$store.getters['plan/getObjectives']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    getSubByCat() {
      const vm = this
      vm.byCategoryId(vm.selectedCategoria._id).then(() => {
        vm.selectedObjetivoDesarrollo = null
        vm.subcategories = vm.$store.getters['subcategory/getSubcategories']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    closeTrading(id) {
      const vm = this
      vm.closeTracing(id).then(() => {
        for (let index in vm.tracings) {
          if (vm.tracings[index]._id == id) {
            vm.tracings.splice(index, 1)
          }
        }
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'C.P./S.D eliminado',
          closeable: true,
          duration: 5000
        })
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    _clearForm() {
      const vm = this
      vm.selectedObjetivo = null
      vm.selectedObjetivoDesarrollo = null
      vm.selectedColaborador = null
      vm.selectedCategoria = null
      vm.date = null
    },
    _tracingShortness() {
      const vm = this
      if (vm.tracings.length > 0) {
        if (vm.tracings.length < vm.user.profile.suggested_cp) {
          vm.suggested = +(vm.user.profile.suggested_cp) - +(vm.tracings.length)
        }
      } else {
        vm.suggested = vm.user.profile.suggested_cp
      }
    },
    customLabel: function(value){
      return `${value.name}`;
    }
  },
  watch: {
    moveobjetivo: function(){
      let moveobjetivo = this.moveobjetivo
      if(this.moveobjetivo === true) {
          this.$emit('can-continue', {value: true});
          this.$emit('completed-step', {value: true});
      } else {
          this.$emit('can-continue', {value: false});
      }
    },
    drawer : function() {
      this.$parent.overlay = !this.$parent.overlay
      this.$emit('clase', this.$parent.overlay)
      // console.log(this.$parent.overlay)
      const el = document.querySelector('.overlay')

      if (this.$parent.overlay) {
        el.classList.add('open')
      } else {
        el.classList.remove('open')
      }
    },
    drawer2 : function() {
      this.$parent.overlay = !this.$parent.overlay
      this.$emit('clase', this.$parent.overlay)
      const el = document.querySelector('.overlay')

      if (this.$parent.overlay) {
        el.classList.add('open')
      } else {
        el.classList.remove('open')
      }
    },
    tracings: function() {
      const vm = this
      vm._tracingShortness()
      if(vm.tracings.length >= vm.user.profile.suggested_cp) {
        this.$emit('can-continue', {value: true});
      } else {
        this.$emit('can-continue', {value: false});
      }
    },    
    currentStep: function(){
      const vm = this
      if(vm.tracings.length >= vm.user.profile.suggested_cp) {
        this.$emit('can-continue', {value: true});
      } else {
        this.$emit('can-continue', {value: false});
      }
    }
  },
  mounted() {
    const vm = this
    const loading = vm.$toast.loading('Cargando...')
    vm.user = vm.$store.getters['auth/getUserInfo']    
    vm.team = vm.$store.getters['user/getMyTeam']
    vm.plan = vm.$store.getters['plan/getPlan']
    if(vm.user.profile.auth.tabs.indexOf("confirmacion_procesos") != -1)
    {
        vm.title = 'Confirmación de Procesos'
        vm.short_title = 'CP'           
    }
    else
    {
        vm.title = 'Seguimiento Diario'   
        vm.short_title = 'SD'           
    } 

    // vm.nameEntity = (vm.user.profile.name == ) ? ''
    vm.getObjByPlanForList(vm.plan._id).then(() => {
      vm.currentWeekObjectives = vm.$store.getters['objective/getObjectives']
      for (var objective of vm.currentWeekObjectives) {
        objective.name = objective.kpi.name
      }
    }, (error) => {
      loading.hide()
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })            
    vm.getTracingByPlan(vm.plan._id).then(() => {
      vm.tracings = vm.$store.getters['tracing/getPTracing']
      if(vm.tracings.length >= vm.user.profile.suggested_cp) {
        this.$emit('can-continue', {value: true});
      } else {
        this.$emit('can-continue', {value: false});
      }
      vm._tracingShortness()
      loading.hide()      
    }, (error) => {
      loading.hide()
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })
    vm.categoriesList().then(() => {
      vm.categories = vm.$store.getters['category/getCategories']
    }, (error) => {
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })    
  },
  computed: {
    objectives () {
      if (!this.selectedCategoria) {
        return
      }
      return this.categories[this.selectedCategoria].map(categorie => {
        return categorie.categoriesObjective
      })
    },
  }
};

</script>

<style lang="stylus">
</style>


// WEBPACK FOOTER //
// src/views/ps-seguimiento.vue